import {Component} from 'preact'
import {connect} from 'preact-redux'

import Chat from '/chat/src/components/SVGImages/Chat'
import HelpDesk from '/chat/src/components/SVGImages/HelpDesk'
import style from './style.scss'

import TicketModel from '/chat/src/redux/model/ticket/model';

class FooterButton extends Component {
    render() {
        let { orientation, active, color, onClick, text, hasUnread} = this.props
        const styleClass = orientation === 'left' ? style.Left : style.Right
        color = active ? color : '#898989'
        const icon = orientation === 'left' ? <HelpDesk color={color}/> : <Chat color={color}/>
        return (
            <div
                onClick={onClick}
                style={{borderColor: color}}
                className={`${styleClass} ${style.FooterButton}`}>
                    <div className={style.FooterButtonImg}>
                        {icon}
                    </div>
                    <div className={style.FooterButtonText} style={{color: color}}>
                        {this.props.text}
                    </div>
                    {(orientation === 'right' && hasUnread) && <div className={style.UnreadDotContainer}>
                        <div className={style.UnreadDot}> </div>
                    </div>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {hasUnread: TicketModel.getTotalUnread(state) !== 0}
}

export default connect(mapStateToProps)(FooterButton);



// WEBPACK FOOTER //
// ./routes/Footer/FooterButton/FooterButton.js